import type { IconButtonProps } from '../button'

import { IconButton } from '../button'
import { vui } from '../core'

/** Preconfigured icon-only trigger button for `DatePicker` (e.g. used as `TextField`'s `itemRight`). */
export const DatePickerTriggerButton = vui<'button', IconButtonProps>((props, ref) => (
  <IconButton
    aria-label="Open calendar"
    icon="uiCalendarAlt"
    ref={ref}
    size="md"
    title="Open calendar"
    variant="tertiary"
    {...props}
  />
))
DatePickerTriggerButton.displayName = 'DatePickerTriggerButton'

export default DatePickerTriggerButton
